

// import { Box, useTheme } from "@mui/material";
// import CheckIcon from "@mui/icons-material/Check";
// import RemoveIcon from "@mui/icons-material/Remove";

// type RoundedSquareIconProps = {
//   checked?: boolean;
//   indeterminate?: boolean;
//   color?: string;
// };

// export const RoundedSquareIcon = ({
//   checked = false,
//   indeterminate = false,
//   color,
// }: RoundedSquareIconProps) => {
//   const theme = useTheme();
//   const defaultColor = theme.palette.primary.main;

//   // Determinamos si pinta el fondo o no
//   const backgroundColor = checked || indeterminate ? color || defaultColor : "transparent";
//   // Determinamos el color del borde
//   const borderColor = checked || indeterminate ? color || defaultColor : "rgba(0, 0, 0, 0.54)";

//   // Escogemos qué ícono mostrar
//   let icon = null;
//   if (checked) {
//     icon = (
//       <CheckIcon
//         sx={{
//           fontSize: 16,
//           color: "#fff",
//         }}
//       />
//     );
//   } else if (indeterminate) {
//     icon = (
//       <RemoveIcon
//         sx={{
//           fontSize: 16,
//           color: "#fff",
//         }}
//       />
//     );
//   }

//   return (
//     <Box
//       sx={{
//         width: 20,
//         height: 20,
//         borderRadius: "7px",
//         border: `2px solid ${borderColor}`,
//         backgroundColor,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         transition: "all 0.3s ease",
//       }}
//     >
//       {icon}
//     </Box>
//   );
// };


import { Box, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import { adjustColor } from "../../../../core/util/colors/adjust-color";

type RoundedSquareIconProps = {
  checked?: boolean;
  indeterminate?: boolean;
  color?: string;
  disabled?: boolean;
};

export const RoundedSquareIcon = ({
  checked = false,
  indeterminate = false,
  color,
  disabled = false,
}: RoundedSquareIconProps) => {
  const theme = useTheme();
  const defaultColor = theme.palette.primary.main;
  const disabledColor = theme.palette.action.disabled;

  // Determinamos el color del fondo y borde
  const backgroundColor = checked || indeterminate
    ? color || defaultColor
    : "transparent";

  const borderColor = disabled
    ? disabledColor
    : checked || indeterminate
      ? color || defaultColor
      : "rgba(0, 0, 0, 0.54)";

  // Escogemos qué ícono mostrar
  let icon = null;
  if (checked) {
    icon = (
      <CheckIcon
        sx={{
          fontSize: 16,
          color: disabled ? "#bdbdbd" : "#fff", // Icono más claro si está deshabilitado
        }}
      />
    );
  } else if (indeterminate) {
    icon = (
      <RemoveIcon
        sx={{
          fontSize: 16,
          color: disabled ? "#bdbdbd" : "#fff", // Icono más claro si está deshabilitado
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: "7px",
        border: `2px solid ${borderColor}`,
        backgroundColor: disabled
          ? adjustColor(backgroundColor, 200, 0.9) // Reduce la opacidad si está deshabilitado
          : backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        opacity: disabled ? 0.7 : 1, // Reduce ligeramente la opacidad si está deshabilitado
        pointerEvents: disabled ? "none" : "auto", // Desactiva eventos si está deshabilitado
      }}
      data-checked={checked} // Mantiene información sobre el estado
      data-indeterminate={indeterminate} // Mantiene información sobre indeterminate
      data-disabled={disabled} // Indica si está deshabilitado
    >
      {icon}
    </Box>
  );
};
